


































import Vue from 'vue';
import CommunicationService from '~/services/CommunicationService';

const SG_COURSERA_PRELAUNCH_LIST_ID = 'de2ae171-2609-47a4-98fe-87e33359ccfb';

export type SubscriptionState = 'inactive' | 'active' | 'created' | 'removed';

export default Vue.extend({
    name: 'NotifyMeButton',
    data() {
        return {
            subscriptionState: 'inactive' as SubscriptionState,
            loading: true,
        };
    },
    computed: {
        buttonTitle(): string {
            switch (this.subscriptionState) {
                case 'inactive':
                    return "We'll send you an email when it's ready!";
                case 'active':
                    return "I've changed my mind, and don't want to be notified when this launches";
                default:
                    return '';
            }
        },
        buttonDisabled(): boolean {
            return (
                this.loading ||
                this.subscriptionState === 'created' ||
                this.subscriptionState === 'removed'
            );
        },
    },
    methods: {
        async addNotification() {
            this.loading = true;
            const success = await CommunicationService.addSubscription(
                SG_COURSERA_PRELAUNCH_LIST_ID
            ).finally(() => (this.loading = false));

            success && (this.subscriptionState = 'created');
        },
        async removeNotification() {
            this.loading = true;
            const success = await CommunicationService.removeSubscription(
                SG_COURSERA_PRELAUNCH_LIST_ID
            ).finally(() => (this.loading = false));

            success && (this.subscriptionState = 'removed');
        },
        toggleSubscription() {
            if (this.subscriptionState === 'inactive') this.addNotification();
            else if (this.subscriptionState === 'active') this.removeNotification();
        },
    },
    watch: {
        subscriptionState(state) {
            this.$emit('state-changed', state);
        },
    },
    created() {
        CommunicationService.hasSubscription(SG_COURSERA_PRELAUNCH_LIST_ID)
            .then(member => (this.subscriptionState = member ? 'active' : 'inactive'))
            .finally(() => (this.loading = false));
    },
});
